import React, { useState, useEffect } from "react";
import styled from "styled-components/macro";
import { connect } from "react-redux";
import { compose } from "redux";
import moment from "moment";
import { withRouter } from "react-router";
import { mapCompanySelector } from "store/state/auth";
import Avatar from "@material-ui/core/Avatar";
import { getAssetManagerInitials } from "./lenderReportingDashboard.helper";
import { getInstanceDetails, getSubmittedRgis } from "./lenderReportingDashboard.store";
import HeaderComponent from "./headerComponent";
import SubmittedReportHeader from "./submittedReportHeader";
import SubmittedReportsColumnHeader from "./submittedReportsColumnHeader";
import { Typography } from "@material-ui/core";
import { BackButtonText } from "./constants";

const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 1120px;
  min-width: 1120px;
  margin: auto;
  align-items: center;
`;

const ReportAsOfDate = styled.div`
  margin-left: 14px;
  font-family: work sans;
  color: #005AA9;
  font-size: 16px;
`;

const AssetManagerInitials = styled.div`
  width: 100px;
  display: flex;
  justify-content: flex-end;
  padding-right: 15px;
`;

const StyledSubmittedDate = styled(Typography)`
  display: flex;
  align-items: center;
  padding-right: 3px;
  && {
    color: #5F6368;
    font-family: "Work Sans";
    font-size: 16px;
    text-align: right;
  }
`;

const ReportRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-left: 1px solid #dadce0;
  border-right: 1px solid #dadce0;
  border-bottom: 1px solid #dadce0;
  background-color: #ffffff;
  width: 100%;
  cursor: pointer;

   &:first-child {
    border-top: 1px solid #dadce0;
  }
`;

const ReportHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1em;
  box-sizing: border-box;
  z-index: 1;
  min-height: 70px;
`;
const ReportHeaderRowLeftSection = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
`;

const ReportHeaderRowRightSection = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
  justify-content: flex-end;
  padding-left: 50px;
`;

const ImageBanner = styled.div`
  width: 100%;
  height: 320px;
`;

const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  min-height: 500px;
`;

const SubmittedReportsWrapper = styled.div`
  width: 100%;
  margin: 2em 0;
`;

const SubmittedReports = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const EmptyReportsText = styled.div`
  align-self: flex-start;
  margin-left: 15px;
  margin-top: -30px;
  color: #7c7979;
  font-size: 20px;
  font-family: work sans;
`;

const AssetManagerAvatar = styled(Avatar)`
  && {
    background-color: #0F9AD6;
    font-size: 16px;
  }
`;

const LenderReportingSubmittedReports = props => {
  useEffect(() => {
    const reportId = props?.match?.params?.reportId;
    if (reportId) {
      props.getInstanceDetails({ reportId });
    }
  }, [props.match.params.reportId]);

  const [initialRgi, setInitialRgi] = useState({ reportGroup: null, reportGroupInstance: null });

  useEffect(() => {
    if (props.taskDetails?.tasks) {
      setInitialRgi({ ...props.taskDetails });
    }
  }, [props.taskDetails]);
  
  useEffect(() => {
    if (initialRgi && initialRgi.reportGroupInstance) {
      const reportGroupId = initialRgi.reportGroupInstance?.Items[0].reportGroupId;
      props.getSubmittedRgis({ reportGroupId });
    }
  }, [initialRgi]);

  const [submittedReports, setSubmittedReports] = useState([]);
  const [filteredSubmittedReports, setFilteredSubmittedReports] = useState([]);
  const [filterYearsArray, setFilterYearsArray] = useState([]);

  useEffect(() => {
    if (props.submittedRgis) {
      setSubmittedReports(props.submittedRgis);
      const years = ["All"];
      for (const rgi of props.submittedRgis) {
        const year = moment(rgi.asOfDate, "YYYY/MM/DD").year();
        if (years.indexOf(year.toString()) === -1) {
          years.push(year.toString());
        }
      }
      const sortedYears = [...years].sort().reverse();
      setFilterYearsArray(sortedYears);
    }
  }, [props.submittedRgis]);

  const [yearFilter, setYearFilter] = useState("All");

  useEffect(() => {
    const filteredRgis = submittedReports.filter(rgi => {
      if (yearFilter === "All") {
        return submittedReports;
      }
      return yearFilter === moment(rgi.asOfDate, "YYYY/MM/DD").year().toString();
    }).sort((a, b) => moment(b.asOfDate).diff(a.asOfDate));
    setFilteredSubmittedReports(filteredRgis);
  }, [submittedReports, yearFilter]);

  const assetManager = (initialRgi.deal?.assetManager?.firstName != null && initialRgi.deal?.assetManager?.lastName != null) ?
  initialRgi.deal.assetManager : null;
  
  const renderSubmittedReports = filteredRgis => (
    <>
      {filteredRgis.length > 0 && <SubmittedReportsColumnHeader />}
    <DataContainer>
      {filteredRgis.map(rgi => (
        <ReportRowWrapper key={rgi.id} onClick={() => props.history.push(`/lenderReportingDashboard/tasks/${rgi.id}`, { from: BackButtonText.SUBMITTED.FROM })}>
          <ReportHeaderRow>
            <ReportHeaderRowLeftSection>
              <ReportAsOfDate>{moment.utc(rgi.asOfDate).format("MMMM Do, YYYY")}</ReportAsOfDate>
            </ReportHeaderRowLeftSection>
            <ReportHeaderRowRightSection>
              <StyledSubmittedDate>
                {moment(rgi.emailAuth?.lastSent).format("MMMM DD, YYYY")}
              </StyledSubmittedDate>
              <AssetManagerInitials>
                {assetManager && <AssetManagerAvatar>{getAssetManagerInitials(`${assetManager.firstName} ${assetManager.lastName}`)}</AssetManagerAvatar>}
              </AssetManagerInitials>
            </ReportHeaderRowRightSection>
          </ReportHeaderRow>
        </ReportRowWrapper>
      ))}
      {(filteredRgis.length === 0 && !props.isSubmittedReportsLoading) && (
        <EmptyReportsText>No submitted reports to display</EmptyReportsText>
      )}
      </DataContainer>
      </>
  );

  return (
    <PageContainer>
      <ImageBanner>
        <HeaderComponent banner={props?.company?.bannerImage} logo={props?.company?.logoImage} />
      </ImageBanner>
      <>
        <SubmittedReportHeader
          data={initialRgi}
          history={props.history}
          filterYears={filterYearsArray}
          yearFilter={yearFilter}
          setYearFilter={setYearFilter}
        />
        <SubmittedReportsWrapper>
          <SubmittedReports>{renderSubmittedReports(filteredSubmittedReports)}</SubmittedReports>
        </SubmittedReportsWrapper>
      </>
    </PageContainer>
  );
};

const mapStateToProps = ({ lenderReportingDashboard, authentication }) => ({
  ...lenderReportingDashboard,
  company: mapCompanySelector(authentication),
  authentication
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getInstanceDetails,
    getSubmittedRgis
  })
)(LenderReportingSubmittedReports);
